"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _icons = require("@wordpress/icons");

var _edit = _interopRequireDefault(require("./edit"));

var _save = _interopRequireDefault(require("./save"));

var _transforms = _interopRequireDefault(require("./transforms"));

var _deprecated = _interopRequireDefault(require("./deprecated"));

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
const settings = {
  icon: _icons.list,
  edit: _edit.default,
  save: _save.default,
  transforms: _transforms.default,
  deprecated: _deprecated.default
};
var _default = settings;
exports.default = _default;
//# sourceMappingURL=index.js.map